import {ENDPOINTS} from '../config/constants'
import api, {HTTPMethod} from '../helpers/api'
import {
  GetCountriesCatalogRequest,
  GetCountriesCatalogRequestSchema,
  GetCountriesCatalogResponse,
  GetCountriesCatalogResponseSchema,
  GetOnboardedCountriesRequest,
  GetOnboardedCountriesRequestSchema,
  GetOnboardedCountriesResponse,
  GetOnboardedCountriesResponseSchema,
  OnboardCountryRequest,
  OnboardCountryRequestSchema,
  OnboardCountryResponse,
  OnboardCountryResponseSchema,
} from '../types/Markets'

export const getOnboardedCountriesService = (signal?: AbortSignal) => {
  return api<GetOnboardedCountriesRequest, GetOnboardedCountriesResponse>({
    method: HTTPMethod.GET,
    path: ENDPOINTS.LOAD_ONBOARDED_COUNTRIES,
    requestSchema: GetOnboardedCountriesRequestSchema,
    responseSchema: GetOnboardedCountriesResponseSchema,
    signal,
  })()
}

export const getCountriesCatalogService = (signal?: AbortSignal) => {
  return api<GetCountriesCatalogRequest, GetCountriesCatalogResponse>({
    method: HTTPMethod.GET,
    path: ENDPOINTS.LOAD_COUNTRIES_CATALOG,
    requestSchema: GetCountriesCatalogRequestSchema,
    responseSchema: GetCountriesCatalogResponseSchema,
    signal,
  })()
}

export const onboardCountryService = (payload: OnboardCountryRequest) =>
  api<OnboardCountryRequest, OnboardCountryResponse>({
    method: HTTPMethod.POST,
    path: ENDPOINTS.ONBOARD_COUNTRY,
    requestSchema: OnboardCountryRequestSchema,
    responseSchema: OnboardCountryResponseSchema,
  })(payload)
